import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { TokenService } from '../../service/token.service';
import { GlobalService } from '../../service/global.service';
import { CompanyInfo } from '../../model/company.model';
import {
  environment
} from 'src/environments/environment';

@Component({
  selector: 'app-company-select',
  templateUrl: './company-select.component.html',
  styleUrls: ['./company-select.component.css']
})
export class CompanySelectComponent implements OnInit {

  @Output() public onSelected = new EventEmitter();
  @Input() Multiselect: boolean = false;
  @Input() Custom: string = '';

  @Input() ButtonColor: string = 'btn-blue';
  @Input() ButtonOutlineColor: string = 'blue';
  @Input() TableColor: string = 'table-stand-blue';

  selected: string;

  baseurl: string;
  _ForK2: string;
  _EmpCode: string;

  // Primary data
  modelOnPromise: Promise<CompanyInfo[]>
  modelList: CompanyInfo[] = [];

  //search
  txtSearchCompanyCode: string
  txtSearchCompanyName: string

  isSearchSubmitted: boolean = false;

  //Pagination variable
  public indexNo: number = 0;
  public currentPageNumber: number
  public count: number
  public totalPages: number
  public environment: number
  public pagesize: number = 5;


  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private activatedRoute: ActivatedRoute, private TokenService: TokenService, private GlobalService: GlobalService) {
    this.baseurl = environment.base_api;

    this._ForK2 = this.activatedRoute.snapshot.params.ForK2;
    this._EmpCode = localStorage.getItem("EmpCode");
  }

  ngOnInit(): void {
    this.reset();
    this.currentPageNumber = 1;
    this.LoadData();
  }


  btnClick_search() {
    this.isSearchSubmitted = true;
    this.selected = "";
    this.currentPageNumber = 1;
    this.indexNo = 0;
    this.pagesize = 5;
    this.LoadData()
  }

  btnClick_clearSearch() {
    this.reset();
    this.LoadData();
  }

  btnClick_select(param) {
    let x = this.modelList.filter(x => x.CompanyCode == param);
    this.selected = param;
    this.onSelected.emit(x);
  }

  btnClick_multiselect() {
    var listselected = $('[name="checkboxMultiselect"]:checked').filter(function () {
      return !(this as HTMLInputElement).disabled
    });

    let list = [];

    for (let x = 0; x < listselected.length; x++) {
      list.push((<HTMLInputElement>listselected[x]).value);
    }

    let listres = this.modelList.filter(x => list.includes(x.CompanyCode));

    this.onSelected.emit(listres);
  }

  reset() {
    this.txtSearchCompanyCode = "";
    this.txtSearchCompanyName = "";
    this.selected = "";
    this.indexNo = 0;
    this.currentPageNumber = 1;
    this.pagesize = 5;

    this.isSearchSubmitted = false;
  }

  chkallclick(traget) {
    var check = $(traget.currentTarget).is(":checked");
    $('[name="checkboxMultiselect"]').filter(function () {
      return !(this as HTMLInputElement).disabled
    }).prop('checked', check);

    this.btnClick_multiselect();
  }

  //============================ Data Loading [Start] =========================================
  LoadData() {
    this.getlist()
      .then(
        data => {
          this.modelList = data;
          //this.YearList = [...new Set(data.map(event => new Date(event.TimeSheetDate).getFullYear().toString()))];
          this.count = (this.modelList.length != 0) ? data[0].count : 0;
        }
      ).then(() => {
        if (this.count == 0) {
          this.currentPageNumber = 0;
        }
        this.totalPages = Math.ceil(this.count / this.pagesize)
      })
  }

  async getlist(): Promise<CompanyInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * this.pagesize;

      var objectjson = {};

      objectjson['CompanyCode'] = this.txtSearchCompanyCode;
      objectjson['CompanyName'] = this.txtSearchCompanyName;

      objectjson['rowFetch'] = this.pagesize;
      objectjson['rowOFFSet'] = offset;


      let strjson = JSON.stringify(objectjson);

      this.modelOnPromise = this.httpClient
        .post<CompanyInfo[]>(this.baseurl + "Company/GetCompanyModal",
          strjson, httpOptions)
        .toPromise()

      return this.modelOnPromise;
    }
  }


  //============================ Pagination [Start] =========================================
  LoadListPagination(traget) {
    this.currentPageNumber = traget.currentPageNumber;
    this.totalPages = traget.totalPages;
    this.indexNo = traget.index;
  }

  OnLoadListFinished(traget = null) {

    if (traget != null) { // check call function from change page or onloadfrist
      this.LoadListPagination(traget);
      this.LoadData();
    }
  }
  //============================ Pagination [End] =========================================

}
